"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * isClient
 * @description returns true if current runtime is on the browser
 */
const isClient = () => typeof window !== 'undefined';
exports.default = isClient;
